import { render, staticRenderFns } from "./YesNoRadio.vue?vue&type=template&id=21ae95dd&"
import script from "./YesNoRadio.vue?vue&type=script&lang=js&"
export * from "./YesNoRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports